export const matchTelefone =
    /^(\([1-9]{1}[0-9]{1}\)\s(9\s)?[1-9]{1}[0-9]{3}\.[0-9]{4})*$/;
export const matchCartao = /^((\d{4}) (\d{4}) (\d{4}) (\d{4}))*$/;
export const matchCartaoDataValida = /\d+/;
export const matchCpf = /^((\d{3}).(\d{3}).(\d{3})-(\d{2}))*$/;
export const matchCnpj = /^(\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})*$/;
export const matchCep = /^(\d{2}\.\d{3}-\d{3})*$/;
export const matchCode = /[0-9]{5}/gi;
